require('../css/racingProgram.css');
require('../img/searchicon.png');
require('../img/svg/pmu.svg');
require('../img/svg/logo_pmu.svg');
require("flatpickr/dist/flatpickr.css");


/* Ouverture des details d'un cheval */

const openHorseContent = document.querySelectorAll(".open-horse-content");

if (openHorseContent != null) {
    openHorseContent.forEach(function (item) {
        item.addEventListener('click', function () {

            var horseDescription = item.parentNode.parentNode;
            item.children[0].classList.toggle('fa-angle-down');
            item.children[0].classList.toggle('fa-angle-up');
            this.parentElement.parentElement.nextElementSibling.classList.toggle('hidden');

            if (item.children[0].classList.contains('fa-angle-up')){
                horseDescription.style.background = "#f5f5f5";
                item.parentElement.parentElement.nextElementSibling.style.background = "#f5f5f5";
            }
            else {
                horseDescription.style.background = "white";
                item.parentElement.parentElement.nextElementSibling.style.background = "white";
            }
        })
    });
}




/* open meeting */
const openMeeting = document.querySelectorAll('.open-meeting');

openMeeting.forEach(function (item) {
    item.addEventListener('click', function () {

        this.lastElementChild.children[0].classList.toggle('fa-angle-down');
        this.lastElementChild.children[0].classList.toggle('fa-angle-up');
        this.nextElementSibling.classList.toggle('hidden')
        this.classList.toggle('bb');
        if (item.nextElementSibling.nextElementSibling.classList.contains('ban_turfoo')) {
            if (item.nextElementSibling.nextElementSibling.style.display !== "none")
                item.nextElementSibling.nextElementSibling.style.display = "none";
            else
                item.nextElementSibling.nextElementSibling.style.display = "flex";
        }
    })
});


const coursesBet = document.querySelectorAll('.programmes-courses-bet');

coursesBet.forEach(function (item) {
    item.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.open("/go/zeturf-programme.php", "_blank")
    })
});




/*     ouverture onglets        */

const openAllHorseContent = document.querySelector(".open-all-horse-content");
const horseContent = document.querySelectorAll('.horse-content');


if (openAllHorseContent != null) {

    openAllHorseContent.addEventListener('click', function() {

        this.children[0].classList.toggle('fa-angle-up');
        this.children[0].classList.toggle('fa-angle-down');

        horseContent.forEach(function (item) {
            if(item.previousElementSibling.children[1].children[0].children[0].classList.contains('fa-angle-up')) {
                item.previousElementSibling.children[1].children[0].children[0].classList.remove('fa-angle-up')
                item.previousElementSibling.children[1].children[0].children[0].classList.add('fa-angle-down')
            } else {
                item.previousElementSibling.children[1].children[0].children[0].classList.add('fa-angle-up')
                item.previousElementSibling.children[1].children[0].children[0].classList.remove('fa-angle-down')
            }
                item.classList.toggle('hidden');
           /* if (item.classList.contains('hidden') && openAllHorseContent.children[0].classList.contains('fa-angle-up')) {
                item.classList.remove('hidden');
                item.style.background = "#f5f5f5";
            }
            else if (!(item.classList.contains('hidden')) && openAllHorseContent.children[0].classList.contains('fa-angle-down')) {
                item.classList.add('hidden');
                item.style.background = "white";
            }*/
        });

        if (openHorseContent != null) {
            openHorseContent.forEach(function(item) {
                var horseDescription = item.parentNode.parentNode;

                if (openAllHorseContent.children[0].classList.contains('fa-angle-up')) {
                    item.children[0].classList.add('fa-angle-up');
                    item.children[0].classList.remove('fa-angle-down');
                    horseDescription.style.background = "#f5f5f5";
                }

                else if (openAllHorseContent.children[0].classList.contains('fa-angle-down')) {
                    item.children[0].classList.remove('fa-angle-up');
                    item.children[0].classList.add('fa-angle-down');
                    horseDescription.style.background = "white";
                }
            });
        }
    });
}



var headerRight = document.querySelectorAll('.header__wrapper');

var seeAllHorses = document.querySelectorAll('.see-all-horses');

NodeList.prototype.__proto__ = Array.prototype;

if (headerRight != null) {

    headerRight.forEach(function (item) {
        item.addEventListener('click', function () {
            this.children[1].children[0].children[0].classList.toggle('fa-angle-down');
            this.children[1].children[0].children[0].classList.toggle('fa-angle-up');
            this.nextElementSibling.classList.toggle('hidden');
        })
    })

    seeAllHorses.forEach(function (item) {
        item.addEventListener('click', function() {
            let horsesContent = this.parentNode.nextElementSibling;
            var subHeaderRight = horsesContent.querySelectorAll('.sub-header-right');
            subHeaderRight.forEach(function (item) {
                item.parentNode.nextElementSibling.classList.toggle('hidden')
            })
        })
    })

}


var unfoldMe = document.querySelectorAll('.unfold-me');

if (unfoldMe.length > 0) {
    unfoldMe.forEach(function (item) {
        item.addEventListener('click', function () {
            this.nextElementSibling.classList.toggle('hidden');
            if(this.children[1].children[0].children[0].dataset.icon === "angle-up") {
                this.children[1].children[0].children[0].dataset.icon = "angle-down"
            } else {
                this.children[1].children[0].children[0].dataset.icon = "angle-up"
            }
        })
    })
}


// gestion du calendrier


import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
let calendar = flatpickr(".flatpickr", {
    "locale": French,
    "onChange": function(selectedDates, dateStr, instance) {
        let year = this.selectedDates[0].getFullYear().toString();
        year = year.substr(-2);
        let month = this.selectedDates[0].getMonth() + 1;
        month = month.toString();
        let day = this.selectedDates[0].getDate();
        day = day.toString();
        if(day < 10) {
            day = "0" + day;
        }
        if(month < 10) {
            month = "0" + month;
        }
        window.location = "/programmes-courses/" + year + month + day + "/";
    },
    maxDate: new Date().fp_incr(1), // 14 days from now
    minDate: subtractYears(new Date(), 8).fp_incr(1),
    wrap: true,
    disableMobile: "true"
});
function subtractYears(date, years) {
    date.setFullYear(date.getFullYear() - years);
    return date;
}
if (document.querySelector('.hier')) {
    function gettodaydate() {
        var d = new Date();
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();

        if(day < 10) {
            day = "0" + day;
        }

        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    function gettomorrowdate() {
        var d = new Date();
        d.setDate(d.getDate() + 1);
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();
        if(day < 10) {
            day = "0" + day;
        }
        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    function getyesterdaydate() {
        var d = new Date();
        d.setDate(d.getDate() - 1);
        let year = d.getFullYear().toString();
        year = year.substr(-2);
        let month = d.getUTCMonth() + 1;
        month = month.toString();
        let day = d.getDate();
        day = day.toString();
        if(day < 10) {
            day = "0" + day;
        }
        if(month < 10) {
            month = "0" + month;
        }
        var date = year + month + day;
        return date;
    }

    const hier = document.querySelector('.hier');
    const aujourdhui= document.querySelector('.aujourdhui');
    const demain = document.querySelector('.demain');
    var path = window.location.pathname.split('/');

    if (window.location.pathname == "/programmes-courses/" + gettodaydate() + "/" || window.location.pathname == "/programmes-courses/" ) {
       aujourdhui.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettomorrowdate() + "/") {
        demain.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + getyesterdaydate() + "/") {
        hier.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettodaydate() + "/partants/" || window.location.pathname == "/programmes-courses/" ) {
        aujourdhui.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettomorrowdate() + "/partants/") {
        demain.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + getyesterdaydate() + "/partants/") {
        hier.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettodaydate() + "/non-partants/" || window.location.pathname == "/programmes-courses/" ) {
        aujourdhui.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettomorrowdate() + "/non-partants/") {
        demain.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + getyesterdaydate() + "/non-partants/") {
        hier.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettodaydate() + "/les-plus-joues/" || window.location.pathname == "/programmes-courses/" ) {
        aujourdhui.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + gettomorrowdate() + "/les-plus-joues/") {
        demain.classList.add('active');
    } else if (window.location.pathname == "/programmes-courses/" + getyesterdaydate() + "/les-plus-joues/") {
        hier.classList.add('active');
    }
}

if (document.getElementById("myBtn")) {
    // Get the modal
    var modal = document.getElementById('myModal');

// Get the button that opens the modal
    var btn = document.getElementById("myBtn");

// When the user clicks the button, open the modal
    btn.onclick = function() {
        modal.style.display = "block";
    };
}

if(document.getElementById("myBtn2")) {
    // Get the modal
    var modal2 = document.getElementById('myModal2');

// Get the button that opens the modal
    var btn2 = document.getElementById("myBtn2");

// When the user clicks the button, open the modal
    btn2.onclick = function() {
        modal2.style.display = "block";
    }
}

if(document.getElementById("myBtn3")) {
    // Get the modal
    var modal3 = document.getElementById('myModal3');

// Get the button that opens the modal
    var btn3 = document.getElementById("myBtn3");

// When the user clicks the button, open the modal
    btn3.onclick = function() {
        modal3.style.display = "block";
    }
}

if(document.getElementById("myBtn4")) {
    // Get the modal
    var modal4 = document.getElementById('myModal4');

// Get the button that opens the modal
    var btn4 = document.getElementById("myBtn4");

// When the user clicks the button, open the modal
    btn4.onclick = function() {
        modal4.style.display = "block";
    }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
    if (event.target == modal) {
        modal.style.display = "none";
    } else if (event.target == modal2) {
        modal2.style.display = "none";
    } else if (event.target == modal3) {
        modal3.style.display = "none";
    } else if (event.target == modal4) {
        modal4.style.display = "none";
    }
};